<template>
    <div class="flag-selector">
        <div v-if="!drawer" class="header">
            <P class="font1">2026你希望自己</P>
        </div>
        <div v-if="!drawer" class="goals-container">
            <div class="goal-row" v-for="(row, rowIndex) in goalRows" :key="rowIndex">
            <div class="goal-wrapper" :style="getAnimationStyle(rowIndex)">
                <div class="goal" v-for="(goal, index) in row.goals" :key="`${rowIndex}-${index}`" :data-id="goal.id" :class="{ selected: isSelected(goal.id) }" @click="toggleGoal(goal.id)">
                <!-- <div class="goal-icon">{{ goal.emoji }}</div> -->
                <div class="goal-text">{{ goal.text }}</div>
                <div class="check-icon">✓</div>
                </div>
                <!-- 复制元素以实现无缝滚动 -->
                <div class="goal" v-for="(goal, index) in row.goals" :key="`${rowIndex}-${index}-copy`" :data-id="goal.id" :class="{ selected: isSelected(goal.id) }" @click="toggleGoal(goal.id)">
                <!-- <div class="goal-icon">{{ goal.emoji }}</div> -->
                <div class="goal-text">{{ goal.text }}</div>
                <div class="check-icon">✓</div>
                </div>
            </div>
            </div>
        </div>
           <!-- 学习计划 -->
        <transition name="fade">
            <div class="course-container" v-if="drawer">
                <label class="close-btn">
                    <i class="fa fa-close fa-lg" @click="drawer=false"></i>
                </label>
                <div class="img-container">
                    <!-- <p style="color: #fff;font-size: 24px;font-weight: bold;">你的人物形象</p> -->
                    <!-- <p class="title">你的人物形象</p> -->
                    <img class="img1" src="@/assets/25Year/2026-13.webp" alt="" >
                    <p style="font-size: 16px;font-weight: bold;margin:0 auto;margin-top: -35px;">Recharge·Refresh·Rebuild·Reshape</p>
                    <img class="img" :src="currentImage.imgUrl" alt="" >
                    <div style="text-align: center;margin-top: 15px;">
                        <p class="title">{{ReportData.lab}}</p>
                        <p class="title">{{ReportData.visitsLab}}</p>
                        <p class="title">{{ReportData.plansLab}}</p>
                    </div>
                   
                </div>
                
            </div>
        </transition>
        <!-- 按钮 -->
        <div v-if="!drawer" class="footer">
            <button class="confirm-btn" :disabled="selectedGoals.length === 0" @click="confirmSelection">学习计划</button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button class="confirm-btn" @click="drawer=true">生成海报</button>
        </div>
      
    </div>
</template>
  
<script>
export default {
    props: ["ReportData"],
    data() {
        return {
            selectedGoals: [],
            goalRows: [
                {
                    goals: [
                        { id: '1', emoji: '💡', text: '技能精进 → 掌握核心岗位能力' },
                        { id: '2', emoji: '🎤', text: '数据驾驭 → 学会分析和洞察数据' },
                        { id: '3', emoji: '🤝', text: '工具掌握 → 熟练使用新工具/软件' },
                    ]
                },
                {
                    goals: [
                        { id: '4', emoji: '🌟', text: '行业前沿 → 跟踪最新技术与趋势' },
                        { id: '5', emoji: '🤖', text: '创新实践 → 参与创新项目和实验' },
                        { id: '6', emoji: '📱', text: '项目主导 → 主导重要任务和项目' }
                    ]
                },
                {
                    goals: [
                        { id: '7', emoji: '📅', text: '系统思维 → 学会整体设计与思考' },
                        { id: '8', emoji: '📈', text: '团队管理 → 提升团队领导与协作能力' },
                        { id: '9', emoji: '🏭', text: '决策执行 → 提升分析和行动力' },
                    ]
                },
                {
                    goals: [
                        { id: '10', emoji: '🔍', text: '战略思维 → 学会从大局思考问题' },
                        { id: '11', emoji: '🛠️', text: '变革推动 → 带动组织变革和创新' },
                        { id: '12', emoji: '🔧', text: '时间管理 → 提升工作与生活效率' }
                    ]
                },
                {
                    goals: [
                        { id: '13', emoji: '🔍', text: '健康平衡 → 工作与生活保持健康平衡' },
                        { id: '14', emoji: '🛠️', text: '职业规划 → 明确未来发展路径' },
                        { id: '15', emoji: '🔧', text: '抗压适应 → 更好应对压力与变化' }
                    ]
                },
            ],
            drawer:false,
            imgItem:[
                {
                    id:1,
                    imgUrl:require('../../assets/25Year/组合A.png')
                },
                {
                    id:2,
                    imgUrl:require('../../assets/25Year/组合B.png')
                },
                {
                    id:3,
                    imgUrl:require('../../assets/25Year/组合C.png')
                },
                {
                    id:4,
                    imgUrl:require('../../assets/25Year/组合D.png')
                },
                {
                    id:5,
                    imgUrl:require('../../assets/25Year/组合E.png')
                },
                {
                    id:6,
                    imgUrl:require('../../assets/25Year/组合F.png')
                },
                {
                    id:7,
                    imgUrl:require('../../assets/25Year/组合G.png')
                }
            ],
            imgItem1:[
                {
                    id:1,
                    imgUrl:require('../../assets/25Year/组合男1.png')
                },
                {
                    id:2,
                    imgUrl:require('../../assets/25Year/组合男2.png')
                },
                {
                    id:3,
                    imgUrl:require('../../assets/25Year/组合男4.png')
                },
                {
                    id:4,
                    imgUrl:require('../../assets/25Year/组合男5.png')
                },
                {
                    id:5,
                    imgUrl:require('../../assets/25Year/组合男6.png')
                },
                {
                    id:6,
                    imgUrl:require('../../assets/25Year/组合男7.png')
                },
                {
                    id:7,
                    imgUrl:require('../../assets/25Year/组合男8.png')
                },
                {
                    id:8,
                    imgUrl:require('../../assets/25Year/组合男9.png')
                },
                {
                    id:9,
                    imgUrl:require('../../assets/25Year/组合男10.png')
                },
            ],
            currentImage: {}
        }
    },
    methods: {
        getRandomImage() {
            if(this.ReportData.gender=='男'){
                var randomIndex = Math.floor(Math.random() * this.imgItem1.length);
                return this.imgItem1[randomIndex];
            }else{
                var randomIndex = Math.floor(Math.random() * this.imgItem.length);
                return this.imgItem[randomIndex];
            }         
            
        },
        displayRandomImage() {
            this.currentImage = this.getRandomImage();
        },
        toggleGoal(goalId) {
            const index = this.selectedGoals.indexOf(goalId);
            
            
            if (index === -1 && this.selectedGoals.length < 3) {
                this.selectedGoals.push(goalId);
            } else if (index !== -1) {
                this.selectedGoals.splice(index, 1);
            } else {
                alert('最多可选3个目标哦！');
            }
        },
        isSelected(goalId) {
            return this.selectedGoals.includes(goalId);
        },
        confirmSelection() {
            if (this.selectedGoals.length === 0) {
                this.$message({
                    message: '请至少选择一个目标！',
                    type: 'warning',
                    center: true
                })
                return;
            }

            // 获取选择的目标文本
            const selectedGoalTexts = this.selectedGoals.map(goalId => {
                for (const row of this.goalRows) {
                    const foundGoal = row.goals.find(goal => goal.id === goalId);
                    if (foundGoal) return foundGoal.text;
                }
                return null;
            }).filter(text => text !== null); // 过滤掉 null，确保数据干净

            const view = {
                comment: selectedGoalTexts.join(', '),
                // email: this.email
            }
            this.$emit('confirmSelection',view)
            // console.log(selectedGoalTexts);
            // alert('目标提交成功！你选择了：' + selectedGoalTexts.join(', '));
        },
        getAnimationStyle(rowIndex) {
            // 为每行设置不同的动画延迟
            const delay = rowIndex * 1000;
            return {
                animationDelay: `${delay}ms`
            };
        },
        savePoster(){

        }   
    },
    mounted(){
        this.displayRandomImage(); 
    }   
}
</script>
  
<style scoped>

.flag-selector {
    background: 
                url("../../assets/25October/logo.png") right  top  no-repeat,
                url("../../assets/25Year/bg1.jpg")  no-repeat;
    background-size: 100% 100%,cover;
    width: 100%;
    height: 100vh;
    padding-top: 1px;
}
  
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: Arial, sans-serif;
}
  
.header {
    text-align: center;
    margin-top: 8vh;
    margin-bottom: 2vh;
}

.font1 {
    width: 96%;
    margin: 0 auto;
    font-size: 20px;
    text-align: center·;
    color: purple;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.header h1 {
    font-size: 19px;
    color: #333;
}

.goals-container {
    max-width: 600px;
    margin: 0 auto;
}

.goal-row {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
    overflow: hidden;
    position: relative;
    height: 40px;
}

.goal-wrapper {
    display: flex;
    animation: scrollGoals 30s linear infinite;
    animation-fill-mode: forwards;; 
}

.goal {
    background-color: #fff;
    border-radius: 20px;
    padding: 8px 15px;
    margin: 0 5px;
    display: flex;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    transition: all 0.2s;
    /* min-width: 120px; */
}
  
.goal:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}
  
.goal.selected {
    background-color: #e6f7ff;
    color: #1890ff;
}
  
.goal-icon {
    margin-right: 8px;
    font-size: 19px;
}

.goal-text {
    flex: 1;
    font-size: 1rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
  
.check-icon {
    display: none;
    margin-left: 8px;
    font-size: 16px;
}

.goal.selected .check-icon {
    display: block;
}
  
.footer {
    text-align: center;
    margin-top: 20px;
}
  
.confirm-btn {
    background-color: #1890ff;
    color: white;
    border: none;
    border-radius: 20px;
    padding: 10px 25px;
    font-size: 16px;
    cursor: pointer;
}
/* .btn{
    position: absolute;
    bottom:15%;
    display: flex;
    justify-content: center;
    width: 100%;
}
button {
    background: #FBCA1F;
    font-family: inherit;
    padding: 0.6em 1.3em;
    font-weight: 900;
    font-size: 15px;
    border: 2px solid black;
    border-radius: 5px;
    box-shadow: 1px 1px;
}

button:active {
    transform: translate(0.05em, 0.05em);
    box-shadow: 0.05em 0.05em;
} */
.confirm-btn:disabled {
    background-color: #bbb;
    cursor: not-allowed;
}
.highlight {
    font-size: 20px;
    color: purple;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
@keyframes scrollGoals {
    0% {
        transform: translateX(50%);
    }
    100% {
        transform: translateX(-50%);
    } 
}
.course-container{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background-image:
        /* linear-gradient(
            rgba(231, 166, 158, 0.5),
            rgba(236, 189, 182, 0.2)
        ), */
        url("../../assets/25Year/bg1.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}
.img-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    border: gold 3px solid;
    border-radius: 20px;
    background-color: #fcf0df;
    width: 94%;
    height: 90vh;
    margin: 0 auto;
    margin-top: 30px;
}
.img{
    width:80%;
}
.img1{
        width:60%;
        margin-top: -20px;
    }
.title{
    font-family:'font3'; 
    color: purple;
    font-size: 32px;
    font-weight: bolder;
    margin-top: 20px;
    margin: 0;
}
.close-btn{
   margin-left: 95%;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
@media screen and (min-width: 786px) {
    .flag-selector {
        background: 
                    url("../../assets/25Year/pcbg.jpg")  no-repeat;
        background-size:cover;
        width: 100%;
        height: 100vh;
    }
    .goals-container {
        max-width:90vw;
        margin: 0 auto;
    }
    .img{
        width:30%;
    }
    .img1{
        width:25%;
    }
}
</style> .        